import { videos } from '@/content/tutorialVideos.json';
import { getAllDocsPages } from '@/constants/docsNavigation';
import { LEARN_LESSONS } from '@/constants/learnCurriculum';

export const TUTORIAL_VIDEOS = videos;

export function getTutorialVideos(guideType, slug) {
  const key = guideType === 'learn' || guideType === 'pages' ? guideType : 'docs';
  const target = String(slug || '').toLowerCase();
  return videos.filter(video => (video[key] || []).includes(target));
}

export function tutorialNextStop(guideType, page) {
  if (!page?.slug || !page?.href) return null;
  return { label: page.label, href: page.href, autoplay: getTutorialVideos(guideType, page.slug).length > 0 };
}

// The next page in `pages` (after `slug`, wrapping around) that has its own
// tutorial, so every video can end by autoplaying another one.
function nextPageWithVideo(guideType, pages, slug, { includeCurrent = false } = {}) {
  const start = pages.findIndex(page => page.slug === slug);
  for (let step = includeCurrent ? 0 : 1; step <= pages.length; step++) {
    const page = pages[(Math.max(start, 0) + step) % pages.length];
    if (!page || (page.slug === slug && !includeCurrent)) continue;
    if (getTutorialVideos(guideType, page.slug).length) return { label: page.label, href: page.href, autoplay: true };
  }
  return null;
}

export function getDocsNextStop(slug) {
  return nextPageWithVideo('docs', getAllDocsPages(), slug);
}

/** `order` lists lesson slugs in the sequence the learner is following. */
export function getLearnNextStop(slug, { order, includeCurrent = false } = {}) {
  const bySlug = new Map(LEARN_LESSONS.map(lesson => [lesson.slug, lesson]));
  const sequence = [...new Set([...(order || []), ...LEARN_LESSONS.map(lesson => lesson.slug)])]
    .map(item => bySlug.get(item)).filter(Boolean);
  return nextPageWithVideo('learn', sequence, slug, { includeCurrent });
}

export function formatVideoDuration(seconds) {
  // Floor to match the native player's duration readout.
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const minutes = Math.floor(total / 60);
  const rest = String(total % 60).padStart(2, '0');
  return `${minutes}:${rest}`;
}

export function addTutorialVideoBlock(guideType, slug, blocks = []) {
  if (!getTutorialVideos(guideType, slug).length) return blocks;
  if (blocks.some(block => block?.type === 'tutorial-videos')) return blocks;
  return [{ type: 'tutorial-videos', guideType, slug }, ...blocks];
}
